<template>
    <div :class="loadingPercent < 100 ? 'title-view loading-background' : 'title-view loading-background-complete'">
        <div class="outline-box">
            <div>
                <img src="../../../assets/shopopee.png" class="title-img" onerror="this.error = null">
                <br>
                <span class="title-text-part">
                    <span class="shoppee_text_3">3</span>
                    <span class="shoppee_text_D">D</span>
                    <span class="title-text-span-1">Shop</span>
                    <span class="title-text-span-2">opee</span> 商城
                </span>

                <div
                    @click="clickStartBtn"
                    :class="loadingPercent < 100 ? 'loading-num-part num-part-uncomplete' : 'loading-num-part num-part-complete'"
                >
                    <div style="position: relative;" v-show="loadingPercent < 100">
                        <div class="loading_ring">
                            <span class="percent-text">{{loadingPercent}}%</span>
                            <span class="loading_ring_span"></span>
                        </div>
                    </div>

                    <div  class="btn_start_div span-percent-part" v-show="loadingPercent >= 100">
                        <span class="btn_start" v-show="true !== onlyPercent">start</span>
                        <span class="btn_start" v-show="true === onlyPercent">100%</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps(["loadingPercent", "onlyPercent"])
const emits = defineEmits(["clickStartBtn"])

function clickStartBtn(){
    emits("clickStartBtn")
}

</script>

<style scoped>

.outline-box {
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    font-size: 24px;
    font-weight: 600;
    justify-content: center;
    align-items: center;
}

.title-img {
    width: 300px;
    height: 300px;
    user-select:none;
}

.title-text-part {
    user-select:none;
}

.title-text-span-1 {
    color: #b20bff;
    font-size: 2em;
}

.title-text-span-2 {
    color: #17a5ff;
    font-size: 2em;
}

.percent-text {
    user-select:none;
    color: #fff;
}

.span-percent-part {
    width: 100%;
    height: 100%;
    position:relative;
}

.title-view {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    /*background: #6a84b3;*/
    color: #2c3e50;
    z-index: 22;
    transition: all 1.5s ease;
}

.loading-background{
    background: #6a84b3;
}

.loading-background-complete{
    background: #ffffff00;
}

.loading-num-part {
    width: 4em;
    height: 4em;
    border-radius: 50%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    transition: all 1.5s ease;;
}

.num-part-uncomplete {
    margin-top: 4em;
}

.num-part-complete {
    margin-top: 8em;
}

.shoppee_text_3{
    font-size: 1.8em;
    font-family: impact, arial;
    color: #17a5ff;
    text-shadow: 0px 0px 0 #007ecf, 1px -1px 0 #007bca, 2px -2px 0 #0075bf,  3px -3px 0 #006fb5,  4px -4px 0 #0069ab,  5px -5px 0 #0062a1,  6px -6px 0 #005c97,  7px -7px 6px rgba(0, 0, 0, 0.55), 7px -7px 1px rgba(0, 0, 0, 0.5);
}
.shoppee_text_D{
    font-size: 1.8em;
    padding-right: 8px;
    font-family: impact, arial;
    color: #b20bff;
    text-shadow: 0px 0px 0 #8500c3, 1px -1px 0 #7e00b8,2px -2px 0 #7700ae, 3px -3px 0 #7000a4,  4px -4px 0 #69009a,  5px -5px 0 #620090, 6px -6px 0 #5b0085, 7px -7px 6px rgba(0, 0, 0, 0.55), 7px -7px 1px rgba(0, 0, 0, 0.5);
}

.btn_start{  /*去掉下划线*/
    text-decoration: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    /* 设置字体大小 */
    font-size: 24px;
    background: linear-gradient(90deg,#03a9f4,#f441a5,#ffeb3b,#03a9f4);
    background-size: 400%;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    color: #fff;
    /* 字母变大写 */
    text-transform: uppercase;
    /* 设置成胶囊状 */
    border-radius: 50px;
    z-index: 2;
    animation: btn_start_sun 8s infinite;
    user-select: none;

}

/* 设置发光 */
/* .btn_start_div{
    content: "";
    left: -5px;
    right: -5px;
    top: -5px;
    bottom: -5px;
    background: linear-gradient(90deg,#03a9f4,#f441a5,#ffeb3b,#03a9f4);
    background-size: 400%;
    border-radius: 50px;
    filter: blur(20px);
} */

.btn_start_div:hover{
    border-radius: 50%;
    background-color: #ffffff
}
/* 设置发光 */
.btn_start::before{
    content: "";
    position: absolute;
    left: -5px;
    right: -5px;
    top: -5px;
    bottom: -5px;
    background: linear-gradient(90deg,#03a9f4,#f441a5,#ffeb3b,#03a9f4);
    background-size: 400%;
    border-radius: 50px;
    filter: blur(20px);
    z-index: -1;
    animation: btn_start_sun 8s infinite;
}

/* 设置流光 */
@keyframes btn_start_sun{
    100%{
        background-position: -400% 0;
    }
}

.loading_ring{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    width:5em;
    height:5em;
    background:transparent;
    border:3px solid #b20bff;
    border-radius:50%;
    text-align:center;
    line-height:5em;
    font-family:sans-serif;
    font-size:20px;
    color:#03a9f4;
    letter-spacing:4px;
    text-transform:uppercase;
    text-shadow:0 0 10px #03a9f4;
    box-shadow:0 0 20px rgba(0,0,0,.5);
}

.loading_ring:before{
    content:'';
    position:absolute;
    top:-3px;
    left:-3px;
    width:100%;
    height:100%;
    border:3px solid transparent;
    border-top:3px solid #03a9f4;
    border-right:3px solid #03a9f4;
    border-radius:50%;
    animation:animateC 2s linear infinite;
}

.loading_ring_span{
    display:block;
    position:absolute;
    top:calc(50% - 2px);
    left:50%;
    width:50%;
    height:4px;
    background:transparent;
    transform-origin:left;
    animation:animate 2s linear infinite;
}

.loading_ring_span:before{
    content:'';
    position:absolute;
    width:16px;
    height:16px;
    border-radius:50%;
    background:#03a9f4;
    top:-6px;
    right:-8px;
    box-shadow:0 0 20px #03a9f4;
}

@keyframes animateC{
    0%{
        transform:rotate(0deg);
    }
    100%{
        transform:rotate(360deg);
    }
}

@keyframes animate
{
    0%{
        transform:rotate(45deg);
    }
    100%{
        transform:rotate(405deg);
    }
}

</style>